__turbopack_context__.v({
  "axislabel": "WealthCalculatorTeaser-module-scss-module__dEW71a__axislabel",
  "container": "WealthCalculatorTeaser-module-scss-module__dEW71a__container",
  "description": "WealthCalculatorTeaser-module-scss-module__dEW71a__description",
  "descriptionText": "WealthCalculatorTeaser-module-scss-module__dEW71a__descriptionText",
  "desktopButton": "WealthCalculatorTeaser-module-scss-module__dEW71a__desktopButton",
  "graph": "WealthCalculatorTeaser-module-scss-module__dEW71a__graph",
  "inner": "WealthCalculatorTeaser-module-scss-module__dEW71a__inner",
  "mobileButton": "WealthCalculatorTeaser-module-scss-module__dEW71a__mobileButton",
});
